import React from 'react';
import { createUseStyles } from 'react-jss';

export default function AspectRatioContainer(props) {
  const { children } = props;
  const c = useStyles(props);

  return (
    <div className={c.container}>
      <div className={c.ratio}>
        <div className={c.absolute}>
          {children}
        </div>
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    flex: props => props.flex,
    overflow: 'auto'
  },
  ratio: {
    width: '100%',
    paddingTop: props => `${convertRatioToPercent(props.ratio) || '56.25'}%`,
    position: 'relative'
  },
  absolute: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // prevent video content to show scroll bar
    overflow: 'hidden'
  }
});

function convertRatioToPercent(ratio) {
  if (!ratio) return;
  // if it's number or number string return
  if (!isNaN(ratio)) return ratio * 100;

  const [numerator, denominator] = ratio.split('/');

  // take reciprocal and convert to percent
  return denominator / numerator * 100;
}
